export default __webpack_public_path__ + "static/media/WAS0050.34I-35298_-20456_0.82a26e99.jpg";